import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, Row } from "reactstrap";
import { API_URL } from "../../../config";

const AssignModuleModal = ({ addModuleModal, setAddModuleModal, distributorId, setSuccessModal,
  setSuccessMessage,godevicelist}) => {
  const [moduleQty, setModuleQty] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleAssignModule = async () => {
    setError("");

    // ✅ Validation
    if (!moduleQty) {
      return setError("Please enter module quantity");
    }

    if (isNaN(moduleQty) || Number(moduleQty) <= 0) {
      return setError("Enter valid positive number");
    }

    try {
      setLoading(true);

      const token = localStorage.getItem("accessToken");

      const res = await fetch(`${API_URL}/module-txn`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify({
          distributor_id: distributorId,
          available: Number(moduleQty),
        }),
      });

      const data = await res.json();

      if (!data.status) {
        throw new Error(data.message || "Something went wrong");
      }

      // ✅ Success
      setModuleQty("");
      setAddModuleModal(false);
      setSuccessMessage("Modules assigned successfully");
      godevicelist()
setSuccessModal(true);

    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={addModuleModal}
      toggle={() => setAddModuleModal(false)}
      className="connect-box"
      centered={true}
    >
      <ModalHeader className="text-white" toggle={() => setAddModuleModal(false)}>
        <span className="ml-1 roititle text-white">Assign Modules</span>
      </ModalHeader>

      <ModalBody>
        <div className="modal-paragrph">
          <div className="col-lg-12">
            <div className="row">

              <div className="form-group col-lg-12 no-padding">
                <label className="control-label mb-0">
                  Number of modules*
                </label>

                <input
                  type="number"
                  value={moduleQty}
                  onChange={(e) => setModuleQty(e.target.value)}
                  className="client-input"
                  placeholder="Enter module quantity"
                />

                {/* ❌ Error Message */}
                {error && (
                  <div style={{ color: "red", fontSize: "12px" }}>
                    {error}
                  </div>
                )}
              </div>

            </div>

            <div className="py-1 text-center" style={{display:"flex",justifyContent:"center"}}>
              <button
                type="button"
                onClick={handleAssignModule}
                className="btn-primary m-0"
                disabled={loading}
              >
                {loading ? "Assigning..." : "Assign"}

                {/* Loader */}
                {loading && <div id="loader"></div>}
              </button>
            </div>

          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default AssignModuleModal;